import React, { useState } from "react";
import "../css/Faqs.css";

const faqsData = [
  {
    q: "Is PULSE suitable for beginners?",
    a: "Yes. Our programs are scalable. Beginners start with foundations while learning proper movement and strength control."
  },
  {
    q: "Do I need prior gym experience?",
    a: "No experience is required. Our coaches guide you through every phase with structured progressions."
  },
  {
    q: "What type of training do you focus on?",
    a: "Strength training, conditioning, mobility, and athletic performance — no gimmicks or trends."
  },
  {
    q: "Are personal training sessions available?",
    a: "Yes. One-on-one coaching is available as part of selected plans or as add-ons."
  },
  {
    q: "How often should I train each week?",
    a: "Most members train 3–5 times per week depending on goals, recovery, and lifestyle."
  },
  {
    q: "Is this a group class gym?",
    a: "We offer both structured group sessions and individual training paths."
  }
];

const Faqs = () => {
  const [active, setActive] = useState(null);

  const toggle = (i) => {
    setActive(active === i ? null : i);
  };

  return (
    <div className="faqs7">

      {/* ================= HERO ================= */}
      <section className="f7-hero">
        <h1>Questions. Answered.</h1>
        <p>Clear answers. No confusion.</p>
      </section>


      {/* ================= FAQ LIST ================= */}
      <section className="f7-list">
        {faqsData.map((item, i) => (
          <div
            key={i}
            className={`f7-item ${active === i ? "open" : ""}`}
            onClick={() => toggle(i)}
          >
            <div className="f7-question">
              <h3>{item.q}</h3>
              <span>{active === i ? "−" : "+"}</span>
            </div>

            <div className="f7-answer">
              <p>{item.a}</p>
            </div>
          </div>
        ))}
      </section>


      {/* ================= END STRIP ================= */}
      <section className="f7-end">
        <h2>Still Curious?</h2>
        <p>Visit us or speak with a coach — clarity starts with conversation.</p>
      </section>

    </div>
  );
};

export default Faqs;
